import { trimLower } from "../utils/general";
import { get, isEmpty, startCase, map } from "lodash";
import moment from "moment";
import { DATE_FORMAT } from "../constants";
import {
  CREATEDBY_FIRSTNAME,
  CREATEDBY_LASTNAME,
  RATEE_FIRSTNAME,
  RATEE_LASTNAME,
  RATER_FIRSTNAME,
  RATER_LASTNAME,
} from "../constants/literalConstant";
import formateUserName from "./formateUserName";

export const checkNonEmpty = (data) => {
  return data && data.length > 0;
};

export const generateTargetGridData = (data) => {
  return data.map((item) => {
    return {
      ...item,
      createdBy: startCase(
        get(item, CREATEDBY_FIRSTNAME, "") +
          " " +
          get(item, CREATEDBY_LASTNAME, "")
      ),
      firstName: get(item, CREATEDBY_FIRSTNAME, ""),
      lastName: get(item, CREATEDBY_LASTNAME, ""),
      url: get(item, "createdBy.profileImage.fileName", ""),
      dueDate: moment(item.dueDate).format(DATE_FORMAT),
      targetImage: `${process.env.REACT_APP_CLOUD_FRONT_URL}/${get(
        item,
        "logo.fileName",
        ""
      )}`,
    };
  });
};

export const teamScoreAccordionData = (data) => {
  return (
    data &&
    data.length > 0 &&
    data.map((item) => {
      return {
        id: item.skillName ? trimLower(item.skillName) : "",
        heading: item.skillName,
        gridData:
          item.rateeSkillScore &&
          item.rateeSkillScore.length > 0 &&
          generateUserGridData(item.rateeSkillScore),
        chartData:
          item.targetLevelSkillScoreChart &&
          item.targetLevelSkillScoreChart.length > 0 &&
          item.targetLevelSkillScoreChart,
        userChartData: item.individualSkillScoreChart,
      };
    })
  );
};

export const generateUserGridData = (data) => {
  return (
    data &&
    data.length > 0 &&
    data.map((item) => {
      return {
        userId: item.rateeId,
        firstName: get(item, RATEE_FIRSTNAME, ""),
        lastName: get(item, RATEE_LASTNAME, ""),
        fullName: formateUserName(
          get(item, RATEE_FIRSTNAME, "") +
            " " +
            formateUserName(get(item, RATEE_LASTNAME, ""))
        ),
        url: get(item, "ratee.profileImage.fileName", ""),
        averageScore: get(item, "averageScore", ""),
        scoreAssignedByMe: get(item, "scoreAssignedByMe", ""),
      };
    })
  );
};

export const inProgressTabContent = (data) => {
  return (
    !isEmpty(data) &&
    data.map((item) => {
      return {
        firstName: get(item, RATEE_FIRSTNAME, ""),
        lastName: get(item, RATEE_LASTNAME, ""),
        fullName: formateUserName(
          get(item, RATEE_FIRSTNAME, "") +
            " " +
            formateUserName(get(item, RATEE_LASTNAME, ""))
        ),
        url: get(item, "ratee.profileImage.fileName", ""),
        status: `${get(item, "raters", []).length} Pending`,
      };
    })
  );
};

export const generateSkills = (data) => {
  return (
    data &&
    data.length > 0 &&
    data.map((item) => {
      return {
        count: item.averageRateeScore,
        skill: item.skillName,
      };
    })
  );
};

export const fetchSkillAnalytics = (skillAnalytics) => {
  const continueAnalytics = get(skillAnalytics, "continue", []);
  const startAnalytics = get(skillAnalytics, "start", []);
  const stopAnalytics = get(skillAnalytics, "stop", []);

  return {
    analytics: [
      {
        title: "Continue",
        detailsHTML: map(continueAnalytics, ({ feedback }) => {
          return `<p>${feedback}</p>`;
        }).join(""),
      },
      {
        title: "Start",
        detailsHTML: map(startAnalytics, ({ feedback }) => {
          return `<p>${feedback}</p>`;
        }).join(""),
      },
      {
        title: "Stop",
        detailsHTML: map(stopAnalytics, ({ feedback }) => {
          return `<p>${feedback}</p>`;
        }).join(""),
      },
    ],
  };
};

export const generateUserSkills = (skills) => {
  return skills.map((item) => {
    return {
      skill: item.skillName,
      score: item.taggedTargetCount,
      count: item.averageRateeScore,
      ratedByCount: item.ratedByCount,
    };
  });
};

export const columnBarData = (data) => {
  let valueColor = [
    "#44A6FA",
    "#4BD1F3",
    "#77DFB0",
    "#9AD538",
    "#8C9AFA",
    "#E171F8",
  ];
  //getRandomColor()
  return data.map((item, i) => {
    return { ...item, value: item.count, valueColor: valueColor[i] };
  });
};

export const generateCheckinOptions = (data) => {
  let firstArray = [{ name: "All SRS Check-In", value: "all" }];
  let secondArray = checkNonEmpty(data)
    ? data.map((item) => {
        return {
          name: item.name,
          value: item.id,
        };
      })
    : [];
  return firstArray.concat(secondArray);
};

export const generateFrequencyOptions = (data) => {
  let firstArray = [{ name: "All Frequencies", value: "all-frequencies" }];
  let secondArray = checkNonEmpty(data)
    ? data.map((item) => {
        return {
          name: moment(item.startDate).format(DATE_FORMAT),
          value: item.startDate,
        };
      })
    : [];
  return secondArray.length > 0 ? firstArray.concat(secondArray) : [];
};

export const getSelectedUser = (users, userId) => {
  return (
    users && users.length > 0 && users.find(({ userid }) => userid === userId)
  );
};

export const generateQuestionsData = (
  { question, questionResponse, userResponsePieChart },
  expanded
) => {
  let gridData = questionResponse.map((item) => {
    return {
      rater:
        get(item, RATER_FIRSTNAME, "") + " " + get(item, RATER_LASTNAME, ""),
      response: item.response,
    };
  });

  let chartData = userResponsePieChart.responseStatistics.map((item) => {
    return {
      targetName: item.text,
      targetType: item.text,
      count: item.count,
      color: item.color,
      percentage: item.percentage,
      explode: false,
    };
  });

  return { question, gridData, chartData, expanded: expanded || false };
};

export const questionsComments = (comments) => {
  let commentsData =
    checkNonEmpty(comments) &&
    comments.map((item) => {
      return {
        rater:
          get(item, RATER_FIRSTNAME, "") + " " + get(item, RATER_LASTNAME, ""),
        comment: item.comment,
      };
    });

  let otherThanNull = commentsData.some((el) => el.comment !== null);

  return otherThanNull ? commentsData : [];
};

export const generateRatersData = (item) => {
  let accordionData = {
    rater: get(item, RATER_FIRSTNAME, "") + " " + get(item, RATER_LASTNAME, ""),
    score: item.score,
    comments: item.comments,
  };

  let gridData = item.questionResponse.map((item) => {
    return {
      question: item.question,
      response: item.response,
    };
  });

  let chartData = item.userResponsePieChart.responseStatistics.map((item) => {
    return {
      targetName: item.text,
      targetType: item.text,
      count: item.count,
      color: item.color,
      percentage: item.percentage,
      explode: false,
    };
  });

  return { accordionData, gridData, chartData };
};

export const flattenObject = (arr) => {
  const flatObject = {};
  for (let i = 0; i < arr.length; i++) {
    for (const property in arr[i]) {
      flatObject[property] = arr[i][property];
    }
  }
  return flatObject;
};

export const generateUserDownload = (data, userId, skillName) => {
  let getDownloads = data.map((item) => {
    return {
      [item.name]: item.checked,
      [item.imageTagName]: item.base64,
    };
  });
  getDownloads = flattenObject(getDownloads);
  return { ...getDownloads, userId, skillName };
};
